/* Aereo: ficha de producto nueva (envío según hora de corte, barra de pares, precios por variante,
   guía de tallas, barra fija en celular y "Completa tu kit"). Sin dependencias. */
(function () {
  'use strict';

  var root = document.querySelector('.product-page--root');

  function money(cents) {
    var amount = Math.round(cents) / 100;
    var fixed = amount % 1 === 0 ? amount.toFixed(0) : amount.toFixed(2);
    var parts = fixed.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + parts.join('.');
  }

  /* ---------- Envío: "sale HOY" con hora de corte en CDMX ---------- */

  var DAYS = ['domingo', 'lunes', 'martes', 'miércoles', 'jueves', 'viernes', 'sábado'];

  function mexicoNow() {
    var parts = new Intl.DateTimeFormat('en-CA', {
      timeZone: 'America/Mexico_City', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', second: '2-digit', hourCycle: 'h23'
    }).formatToParts(new Date());
    var o = {};
    parts.forEach(function (p) { o[p.type] = p.value; });
    return {
      date: new Date(Date.UTC(+o.year, +o.month - 1, +o.day)),
      minutes: (+o.hour) * 60 + (+o.minute),
      seconds: (+o.hour) * 3600 + (+o.minute) * 60 + (+o.second)
    };
  }

  function isoDay(d) { return d.toISOString().slice(0, 10); }

  function isBusinessDay(d, holidays) {
    var wd = d.getUTCDay();
    return wd !== 0 && wd !== 6 && holidays.indexOf(isoDay(d)) === -1;
  }

  function nextBusinessDay(d, holidays) {
    var n = new Date(d.getTime());
    do { n.setUTCDate(n.getUTCDate() + 1); } while (!isBusinessDay(n, holidays));
    return n;
  }

  function updateShipping(el) {
    var msg = el.querySelector('[data-aereo-envio-msg]');
    if (!msg) return;
    var cutoff = parseInt(el.dataset.cutoff || '14', 10) * 3600;
    var holidays = (el.dataset.holidays || '').split(',').filter(Boolean);
    var now = mexicoNow();

    if (isBusinessDay(now.date, holidays) && now.seconds < cutoff) {
      var left = cutoff - now.seconds;
      var h = Math.floor(left / 3600);
      var m = Math.max(1, Math.ceil((left % 3600) / 60));
      if (m === 60) { h += 1; m = 0; }
      var time = (h > 0 ? h + ' h ' : '') + (m > 0 ? m + ' min' : '');
      msg.innerHTML = '<span class="aereo-envio-dot" aria-hidden="true"></span>Pide en las próximas ' +
        '<span class="aereo-envio-timer">' + time.trim() + '</span> y sale <span class="aereo-envio-hoy">HOY</span>';
      return;
    }

    var ship = nextBusinessDay(now.date, holidays);
    var tomorrow = new Date(now.date.getTime());
    tomorrow.setUTCDate(tomorrow.getUTCDate() + 1);
    var label = isoDay(ship) === isoDay(tomorrow) ? 'mañana' : 'el ' + DAYS[ship.getUTCDay()];
    msg.innerHTML = 'Pide hoy y sale <span class="aereo-envio-hoy">' + label + '</span>';
  }

  document.querySelectorAll('[data-aereo-envio]').forEach(function (el) {
    updateShipping(el);
    setInterval(function () { updateShipping(el); }, 30000);
  });

  /* ---------- Barra de pares de la promoción ---------- */

  function renderPromo(el, pairs) {
    var tiers = JSON.parse(el.dataset.tiers);
    var promo = el.dataset.promo;
    var ctx = el.dataset.context;
    var msg = el.querySelector('[data-aereo-promo-msg]');
    var fill = el.querySelector('[data-aereo-promo-fill]');
    var current = -1;
    tiers.forEach(function (t, i) { if (pairs >= t[0]) current = i; });

    var text;
    if (current === tiers.length - 1) {
      text = '¡Tienes <b>' + tiers[current][1] + '%</b>! El descuento más alto de ' + promo;
    } else {
      var next = tiers[current + 1];
      var missing = next[0] - pairs;
      var parMas = missing === 1 ? '1 par más' : missing + ' pares más';
      if (current === -1 && pairs === 0) {
        text = 'Agrega ' + next[0] + ' pares y llévate <b>' + next[1] + '%</b>';
      } else if (current === -1) {
        text = 'Agrega ' + parMas + ' y llévate <b>' + next[1] + '%</b>';
      } else if (ctx === 'cart') {
        text = 'Agrega ' + parMas + ' y llévate <b>' + next[1] + '%</b>';
      } else {
        text = 'Tienes ' + tiers[current][1] + '%. Agrega ' + parMas + ' para <b>' + next[1] + '%</b>';
      }
    }
    msg.innerHTML = text;

    // Tramos iguales entre nodos (0 → 1/3 → 2/3 → 1)
    var progress = 0;
    var prevQty = 0;
    for (var i = 0; i < tiers.length; i++) {
      var seg = 100 / tiers.length;
      if (pairs >= tiers[i][0]) { progress = seg * (i + 1); prevQty = tiers[i][0]; continue; }
      progress += seg * Math.max(0, (pairs - prevQty) / (tiers[i][0] - prevQty));
      break;
    }
    fill.style.width = Math.min(100, progress) + '%';
    el.querySelectorAll('[data-aereo-promo-node]').forEach(function (node, idx) {
      node.classList.toggle('is-reached', idx <= current);
      node.classList.toggle('is-current', idx === current);
    });
  }

  var promoBars = document.querySelectorAll('[data-aereo-promo-barra]');
  function refreshPromo() {
    if (!promoBars.length) return;
    fetch('/cart?view=aereo', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) { promoBars.forEach(function (el) { renderPromo(el, data.pairs || 0); }); })
      .catch(function () {});
  }
  if (promoBars.length) {
    promoBars.forEach(function (el) { renderPromo(el, parseInt(el.dataset.pairs || '0', 10)); });
    refreshPromo();
    window.addEventListener('theme:cart:updated', refreshPromo);
    window.addEventListener('theme:cart:productAdded', refreshPromo);
  }

  /* ---------- Guía de tallas ---------- */

  var guia = document.querySelector('[data-aereo-guia]');
  if (guia) {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-aereo-guia-open]')) {
        e.preventDefault();
        if (typeof guia.showModal === 'function') guia.showModal(); else guia.setAttribute('open', '');
        document.documentElement.classList.add('aereo-no-scroll');
      } else if (e.target.closest('[data-aereo-guia-close]') || e.target === guia) {
        guia.close ? guia.close() : guia.removeAttribute('open');
      }
    });
    guia.addEventListener('close', function () { document.documentElement.classList.remove('aereo-no-scroll'); });
  }

  /* ---------- Reseñas: el widget completo de Judge.me queda oculto hasta "Ver todas" ---------- */

  var resenas = document.querySelector('[data-aereo-resenas]');
  var jdgmSection = document.querySelector('[id*="__judgeme_reviews"]');
  if (jdgmSection) {
    var hasReviews = resenas && resenas.dataset.showReviews === 'true';
    jdgmSection.classList.add('aereo-jdgm-collapsed');
    var toggle = resenas && resenas.querySelector('[data-aereo-resenas-toggle]');
    var write = resenas && resenas.querySelector('[data-aereo-resenas-write]');
    var setOpen = function (open) {
      jdgmSection.classList.toggle('aereo-jdgm-collapsed', !open);
      resenas.classList.toggle('is-expanded', open);
      if (toggle) {
        toggle.setAttribute('aria-expanded', String(open));
        toggle.textContent = open ? toggle.dataset.openLabel : toggle.dataset.label;
      }
    };
    if (hasReviews && toggle) {
      toggle.dataset.label = toggle.textContent.trim();
      toggle.addEventListener('click', function () {
        var open = jdgmSection.classList.contains('aereo-jdgm-collapsed');
        setOpen(open);
        if (open) jdgmSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
    // Paginación de Judge.me: atenuar mientras carga la otra página y subir al inicio de las reseñas
    jdgmSection.addEventListener('click', function (e) {
      var pageBtn = e.target.closest('.jm-pagination-controls__button');
      if (!pageBtn || pageBtn.disabled || pageBtn.classList.contains('jm-pagination-controls__button--active')) return;
      var list = jdgmSection.querySelector('.jm-review-widget__body');
      if (!list) return;
      jdgmSection.classList.add('is-paging');
      var done = function () {
        jdgmSection.classList.remove('is-paging');
        obs.disconnect();
        var top = jdgmSection.getBoundingClientRect().top + window.scrollY - 90;
        if (window.scrollY > top) window.scrollTo({ top: top, behavior: 'smooth' });
      };
      var obs = new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(done, 120); });
      var timer = setTimeout(done, 4000);
      obs.observe(list, { childList: true, subtree: true, characterData: true });
    });
    if (write) {
      write.addEventListener('click', function () {
        setOpen(true);
        var btn = jdgmSection.querySelector('[data-testid="write-review-button"], .jm-button--primary, .jdgm-write-rev-link');
        if (btn) btn.click(); else jdgmSection.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  if (!root) return;

  /* ---------- Variante: botón con precio, etiquetas y precios de la promo ---------- */

  var productId = root.dataset.productId;
  var primary = root.querySelector('.product-buy-buttons--primary');
  var ctaText = root.querySelector('.product-buy-buttons--cta-text');
  var sticky = document.querySelector('[data-aereo-barra-fija]');
  var stickyBtn = sticky && sticky.querySelector('[data-aereo-barra-btn]');
  var stickyVariant = sticky && sticky.querySelector('[data-aereo-barra-variant]');

  function variantsJson() {
    var el = root.querySelector('[id^="variant--json-"]') ;
    try { if (el) return JSON.parse(el.textContent); } catch (e) {}
    // Productos sin opciones: el theme no imprime las variantes, se usan las de la capa de la galería
    var m = root.querySelector('[data-aereo-media]');
    try { return m ? (JSON.parse(m.textContent).variants || []) : []; } catch (e) { return []; }
  }

  function currentVariant() {
    var select = root.querySelector('.product-buy-buttons--select');
    var id = select && (select.querySelector('option[selected]') || select.options[select.selectedIndex]);
    id = id && id.value;
    var found = null;
    variantsJson().forEach(function (v) { if (String(v.id) === String(id)) found = v; });
    return found;
  }

  function updateOptionLabels() {
    root.querySelectorAll('.product-options--option').forEach(function (opt) {
      var header = opt.querySelector('.radios--header');
      var checked = opt.querySelector('input[type=radio]:checked');
      if (!header || !checked) return;
      var cur = header.querySelector('.radios--option-current');
      if (!cur) {
        cur = document.createElement('span');
        cur.className = 'radios--option-current';
        cur.setAttribute('data-item', 'nav-text');
        header.querySelector('label').after(cur);
      }
      cur.textContent = checked.value.replace(' - ', ' a ');
    });
  }

  function applyVariant(v) {
    updateOptionLabels();
    if (!v) return;
    if (primary && ctaText && v.available) {
      ctaText.innerText = 'Agregar al carrito · ' + money(v.price);
    }
    root.querySelectorAll('[data-aereo-promo-from-price]').forEach(function (el) {
      var keep = parseInt(el.closest('[data-keep-pct]').dataset.keepPct, 10);
      el.textContent = money(v.price * keep / 100);
    });
    root.querySelectorAll('[data-aereo-unit]').forEach(function (el) {
      el.textContent = money(v.price * parseInt(el.dataset.keepPct, 10) / 100) + ' c/u';
    });
    if (stickyBtn) {
      stickyBtn.textContent = v.available ? 'Agregar · ' + money(v.price) : 'Agotado';
      stickyBtn.disabled = !v.available;
      if (stickyVariant) stickyVariant.textContent = v.title.replace(' - ', ' a ');
    }
  }

  window.addEventListener('theme:product:' + productId + ':variantChanged', function (e) {
    var v = e.detail && e.detail.variant;
    // El theme cambia el texto del botón en el mismo evento; lo sobrescribimos después,
    // leyendo la variante seleccionada en ese momento (por si hubo dos cambios seguidos)
    setTimeout(function () { applyVariant(currentVariant() || v); }, 0);
  });
  applyVariant(currentVariant());

  /* ---------- Galería: capa (etiqueta, sello, zoom, contador), fotos por color, swipe y zoom ---------- */

  var mediaJson = root.querySelector('[data-aereo-media]');
  var mediaInfo = { colorIndex: null, media: [] };
  try { if (mediaJson) mediaInfo = JSON.parse(mediaJson.textContent); } catch (e) {}
  var galleries = root.querySelectorAll('.product-page--desktop-container .product-media--variants, .product-page--mobile-container .product-media--variants');
  var badgesTpl = root.querySelector('[data-aereo-media-badges]');
  galleries.forEach(function (g) {
    if (getComputedStyle(g).position === 'static') g.style.position = 'relative';
    if (badgesTpl) g.appendChild(badgesTpl.content.cloneNode(true));
  });

  function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/[-_]/g, ' '); }
  var colorNames = [];
  if (mediaInfo.colorIndex !== null) {
    variantsJson().forEach(function (v) {
      var c = v.options[mediaInfo.colorIndex];
      if (c && colorNames.indexOf(c) === -1) colorNames.push(c);
    });
  }
  // Color de cada foto: el nombre de color más largo que aparezca en su texto alternativo (o en el nombre del archivo)
  function colorOf(text) {
    var best = null;
    var hay = ' ' + norm(text) + ' ';
    colorNames.forEach(function (c) {
      var n = norm(c);
      if (new RegExp('[^a-z]' + n.replace(/ /g, '[^a-z]+') + '[^a-z]').test(hay) && (!best || n.length > norm(best).length)) best = c;
    });
    return best;
  }
  mediaInfo.media.forEach(function (m) { m.color = colorOf(m.alt) || colorOf(m.file); });

  var visibleIds = mediaInfo.media.map(function (m) { return m.id; });
  var activeId = null;
  var lastColor;

  function currentColor() {
    if (mediaInfo.colorIndex === null) return null;
    var opt = root.querySelectorAll('.product-options--option')[mediaInfo.colorIndex];
    var checked = opt && opt.querySelector('input[type=radio]:checked');
    return checked ? checked.value : null;
  }

  function setActive(id, notify) {
    activeId = id;
    root.querySelectorAll('.product-media--thumb').forEach(function (t) {
      t.setAttribute('data-active', String(parseInt(t.dataset.id, 10) === id));
    });
    if (notify) window.trigger('theme:product:' + productId + ':mediaChanged', { id: id });
    updateCount();
  }

  function updateCount() {
    var idx = visibleIds.indexOf(activeId);
    root.querySelectorAll('[data-aereo-media-count]').forEach(function (el) {
      el.textContent = visibleIds.length > 1 ? (Math.max(idx, 0) + 1) + ' / ' + visibleIds.length : '';
    });
  }

  function filterByColor(color) {
    var matching = mediaInfo.media.filter(function (m) { return color && m.color === color; });
    if (!matching.length && color) {
      // Sin fotos reconocidas de ese color: se muestra la foto que la variante tiene asignada (si hay)
      var v = currentVariant();
      var fid = v && v.featured_media && v.featured_media.id;
      matching = mediaInfo.media.filter(function (m) { return m.id === fid; });
    }
    var list = matching.length ? matching : mediaInfo.media;
    visibleIds = list.map(function (m) { return m.id; });
    root.querySelectorAll('.product-media--root[data-id], .product-media--thumb[data-id]').forEach(function (el) {
      var id = parseInt(el.dataset.id, 10);
      if (isNaN(id)) return;
      el.style.display = visibleIds.indexOf(id) === -1 ? 'none' : '';
    });
    // Al cambiar de color se empieza siempre en la primera foto de ese color (el theme salta a la foto asignada a
    // la variante, que puede ser la segunda o tercera). Si solo cambió la talla, se queda la foto que se veía.
    var colorChanged = color !== lastColor;
    lastColor = color;
    var current = root.querySelector('.product-media--thumb[data-active="true"]');
    var curId = current ? parseInt(current.dataset.id, 10) : activeId;
    if (colorChanged || visibleIds.indexOf(curId) === -1) setActive(visibleIds[0], true);
    else setActive(curId, false);
    buildCollage();
  }

  // Collage de escritorio (como el diseño): debajo de la foto principal, las demás fotos del color en 2 columnas.
  // Al tocar una se abre el zoom en esa foto. En celular se esconde con CSS.
  var desktopGallery = root.querySelector('.product-page--desktop-container .product-media--variants--root');
  var collage = null;
  if (desktopGallery) {
    collage = document.createElement('div');
    collage.className = 'aereo-collage';
    desktopGallery.insertAdjacentElement('afterend', collage);
  }
  function buildCollage() {
    if (!collage) return;
    var items = mediaInfo.media.filter(function (m) { return visibleIds.indexOf(m.id) > 0 && m.type === 'image'; });
    collage.innerHTML = '';
    items.forEach(function (m) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'aereo-collage__item';
      b.dataset.aereoCollage = m.id;
      b.setAttribute('aria-label', 'Ver foto en grande');
      var img = document.createElement('img');
      var src = (m.src.indexOf('//') === 0 ? 'https:' : '') + m.src;
      var sep = src.indexOf('?') === -1 ? '?' : '&';
      img.src = src + sep + 'width=600';
      img.srcset = src + sep + 'width=400 400w, ' + src + sep + 'width=600 600w, ' + src + sep + 'width=900 900w';
      img.sizes = '(min-width: 1024px) 270px, 1px';
      img.alt = m.alt || '';
      img.loading = 'lazy';
      img.width = m.w; img.height = m.h;
      b.appendChild(img);
      collage.appendChild(b);
    });
    collage.hidden = !items.length;
  }

  if (mediaInfo.media.length) {
    filterByColor(currentColor());
    window.addEventListener('theme:product:' + productId + ':variantChanged', function () {
      setTimeout(function () { filterByColor(currentColor()); }, 60);
    });
    window.addEventListener('theme:product:' + productId + ':mediaChanged', function (e) {
      if (e.detail && e.detail.id !== activeId) { activeId = e.detail.id; updateCount(); }
    });
  }

  function step(dir) {
    var idx = visibleIds.indexOf(activeId);
    var next = visibleIds[(idx + dir + visibleIds.length) % visibleIds.length];
    if (next !== undefined) setActive(next, true);
  }

  // Deslizar la foto principal en celular
  root.querySelectorAll('.product-page--mobile-container .product-media--container').forEach(function (area) {
    var sx = 0, sy = 0, moved = false;
    area.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; sy = e.touches[0].clientY; moved = false; }, { passive: true });
    area.addEventListener('touchmove', function (e) {
      if (Math.abs(e.touches[0].clientX - sx) > 10) moved = true;
    }, { passive: true });
    area.addEventListener('touchend', function (e) {
      var dx = e.changedTouches[0].clientX - sx, dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) step(dx < 0 ? 1 : -1);
    });
    area.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
  });

  // Zoom a pantalla completa (PhotoSwipe, como el theme Stretch)
  var PSWP_VERSION = '5.4.4';
  var pswpLoader = null;
  function loadPswp() {
    if (!pswpLoader) {
      var css = document.createElement('link');
      css.rel = 'stylesheet';
      css.href = 'https://cdn.jsdelivr.net/npm/photoswipe@' + PSWP_VERSION + '/dist/photoswipe.css';
      document.head.appendChild(css);
      // Versión UMD: Shopify minifica los assets y no admite import() dinámico
      pswpLoader = new Promise(function (resolve, reject) {
        if (window.PhotoSwipe) return resolve(window.PhotoSwipe);
        var s = document.createElement('script');
        s.src = 'https://cdn.jsdelivr.net/npm/photoswipe@' + PSWP_VERSION + '/dist/umd/photoswipe.umd.min.js';
        s.onload = function () { resolve(window.PhotoSwipe); };
        s.onerror = reject;
        document.head.appendChild(s);
      });
    }
    return pswpLoader;
  }
  var ARROW = '<svg aria-hidden="true" class="pswp__icn" viewBox="0 0 24 24" width="24" height="24"><path d="M15 5l-7 7 7 7" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var CLOSE = '<svg aria-hidden="true" class="pswp__icn" viewBox="0 0 24 24" width="24" height="24"><path d="M6 6l12 12M18 6L6 18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>';

  function openZoom(startId) {
    var items = mediaInfo.media.filter(function (m) { return visibleIds.indexOf(m.id) !== -1 && m.type === 'image'; });
    if (!items.length) return;
    var start = Math.max(0, items.map(function (m) { return m.id; }).indexOf(startId || activeId));
    loadPswp().then(function (PhotoSwipe) {
      var pswp = new PhotoSwipe({
        dataSource: items.map(function (m) { return { src: (m.src.indexOf('//') === 0 ? 'https:' : '') + m.src, width: m.w, height: m.h, alt: m.alt || '' }; }),
        index: start,
        mainClass: 'aereo-pswp',
        bgOpacity: 1,
        showHideAnimationType: 'fade',
        initialZoomLevel: 'fit',
        secondaryZoomLevel: function (zoomLevelObject) { return Math.min(zoomLevelObject.fit * 2.5, 4); },
        maxZoomLevel: 4,
        wheelToZoom: true,
        imageClickAction: 'zoom',
        tapAction: 'zoom',
        doubleTapAction: 'zoom',
        bgClickAction: 'close',
        padding: { top: 64, bottom: 64, left: 0, right: 0 },
        arrowPrevSVG: ARROW,
        arrowNextSVG: ARROW,
        closeSVG: CLOSE,
        zoom: false,
        counter: true,
        closeTitle: 'Cerrar',
        zoomTitle: 'Acercar',
        arrowPrevTitle: 'Anterior',
        arrowNextTitle: 'Siguiente',
        errorMsg: 'No se pudo cargar la foto'
      });
      pswp.on('close', function () {
        var m = items[pswp.currIndex];
        if (m && m.id !== activeId) setActive(m.id, true);
      });
      pswp.init();
    });
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-aereo-zoom]')) { e.preventDefault(); openZoom(); return; }
    var tile = e.target.closest('[data-aereo-collage]');
    if (tile) { e.preventDefault(); openZoom(parseInt(tile.dataset.aereoCollage, 10)); return; }
    var media = e.target.closest('.product-media--variants .product-media--root');
    if (media && !e.target.closest('a, button, video, model-viewer')) { e.preventDefault(); openZoom(); }
  });

  /* ---------- Loader del botón al agregar ---------- */

  var form = primary && primary.closest('form');
  if (form) {
    form.addEventListener('submit', function () {
      if (primary.disabled) return;
      primary.setAttribute('aria-busy', 'true');
      if (stickyBtn) stickyBtn.classList.add('is-loading');
    });
    var stopLoading = function () {
      primary.setAttribute('aria-busy', 'false');
      if (stickyBtn) stickyBtn.classList.remove('is-loading');
    };
    window.addEventListener('theme:cart:productAdded', function () { setTimeout(stopLoading, 300); });
    window.addEventListener('theme:cart:updated', function () { setTimeout(stopLoading, 300); });
  }

  /* ---------- Barra fija en celular ---------- */

  if (sticky && primary && 'IntersectionObserver' in window) {
    var footerReached = false;
    var visible = false;
    var update = function () {
      var show = !visible && !footerReached && window.scrollY > 200;
      sticky.classList.toggle('is-visible', show);
      document.documentElement.classList.toggle('aereo-sticky-on', show);
      sticky.setAttribute('aria-hidden', show ? 'false' : 'true');
      if (stickyBtn) stickyBtn.tabIndex = show ? 0 : -1;
    };
    new IntersectionObserver(function (entries) {
      visible = entries[0].isIntersecting || entries[0].boundingClientRect.top > window.innerHeight;
      update();
    }).observe(primary);
    var footer = document.querySelector('.footer--root, footer');
    if (footer) {
      new IntersectionObserver(function (entries) { footerReached = entries[0].isIntersecting; update(); }).observe(footer);
    }
    stickyBtn.addEventListener('click', function () {
      if (primary.disabled) return;
      primary.click();
    });
  }
})();

/* ---------- Completa tu kit: talla preseleccionada (la de la ficha) y agregar ---------- */
(function () {
  'use strict';

  function selectSize(card, btn) {
    card.querySelectorAll('[data-aereo-kit-size]').forEach(function (b) { b.setAttribute('aria-checked', String(b === btn)); });
    card.classList.remove('needs-size');
  }

  // Al cambiar la talla en la ficha, se preselecciona la misma en el kit
  var root = document.querySelector('.product-page--root');
  if (root) {
    window.addEventListener('theme:product:' + root.dataset.productId + ':variantChanged', function () {
      var sizeInput = [].slice.call(root.querySelectorAll('.product-options--option input[type=radio]:checked'))
        .filter(function (i) { return i.value.indexOf('(') !== -1; })[0];
      if (!sizeInput) return;
      var label = sizeInput.value.split(' (')[0].trim();
      document.querySelectorAll('[data-aereo-kit-card]').forEach(function (card) {
        var match = card.querySelector('[data-aereo-kit-size="' + label + '"]:not([disabled])');
        if (match) selectSize(card, match);
      });
    });
  }

  document.addEventListener('click', function (e) {
    var size = e.target.closest('[data-aereo-kit-size]');
    if (size && !size.disabled) { selectSize(size.closest('[data-aereo-kit-card]'), size); return; }

    var add = e.target.closest('[data-aereo-kit-add]');
    if (!add || add.getAttribute('aria-busy') === 'true') return;
    var card = add.closest('[data-aereo-kit-card]');
    var chosen = card.querySelector('[data-aereo-kit-size][aria-checked="true"]');
    var variant = add.dataset.variant || (chosen && chosen.dataset.variant);
    if (!variant) { card.classList.add('needs-size'); return; }

    add.setAttribute('aria-busy', 'true');
    var opts = { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: new URLSearchParams({ id: variant, quantity: 1 }).toString() };
    var done = function () {
      add.setAttribute('aria-busy', 'false');
      card.classList.add('is-added');
      setTimeout(function () { card.classList.remove('is-added'); }, 2500);
    };
    if (window.theme && theme.cart && theme.cart.addItem) {
      theme.cart.addItem(opts, variant).then(function () {
        done();
        if (theme.settings && theme.settings.cart_type === 'drawer' && theme.drawer) theme.drawer.open('right', 'cart-drawer', add);
      }).catch(done);
    } else {
      fetch('/cart/add.js', opts).then(function () { window.location.href = '/cart'; });
    }
  });
})();
